import { __assign, __rest } from "tslib";
import BannerProvider from '@office-start/banner-service';
import { DimeProvider } from '@office-start/dime-service';
import { HarmonyItemDataProvider } from '@office-start/harmony-item-data-service';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import { HarmonyThemeDataProvider } from '@office-start/theming-service';
import React from 'react';
export var HarmonyProvider = function (_a) {
    var children = _a.children, officeFluentProviderProps = __rest(_a, ["children"]);
    return (React.createElement(HarmonyItemDataProvider, null,
        React.createElement(OfficeFluentProvider, __assign({}, officeFluentProviderProps),
            React.createElement(HarmonyThemeDataProvider, null,
                React.createElement(DimeProvider, null,
                    React.createElement(BannerProvider, null, children))))));
};
//# sourceMappingURL=HarmonyProvider.js.map